import React from "react";
import { forestRescueStory } from "../../story/forestRescueStory";
import { StoryPlayer } from "./components/StoryPlayer";
import "./ForestRescueEbook.css";

export function ForestRescueEbook() {
  return (
    <div className="ebook-app">
      <StoryPlayer story={forestRescueStory} />
    </div>
  );
}
